export const generateGeminiTtsAudio = async (
  inputLocation,
  outputLocation,
  alexVoice = "Autonoe",
  jordanVoice = "Puck"
) => {
  const url = "https://gemini-tts-api-554232563465.us-west1.run.app/run";
  const payload = {
    input_location: inputLocation,
    output_location: outputLocation,
    alex_voice: alexVoice,
    jordan_voice: jordanVoice,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.detail || `Gemini TTS request failed: ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("Error requesting Gemini TTS generation:", error);
    return null;
  }
};
